import React from "react";
import { Outlet } from "react-router-dom";
import { FacebookAuthProvider } from "@/contexts/FacebookAuthContext";
import { ClientProvider } from "@/contexts/ClientContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import Header from "@/components/organisms/Header";
import Sidebar from "@/components/organisms/Sidebar";

function Layout() {
  return (
    <SettingsProvider>
      <FacebookAuthProvider>
        <ClientProvider>
          <div className="min-h-screen bg-gray-50">
            <Header />
            <div className="flex">
              <Sidebar />
              <main className="flex-1">
                <Outlet />
              </main>
            </div>
          </div>
        </ClientProvider>
      </FacebookAuthProvider>
    </SettingsProvider>
  );
}

export default Layout;
